<template>
  <div>
    <BulkAccessionsView :selectedStatuses="statuses"></BulkAccessionsView>
  </div>
</template>

<script>
import BulkAccessionsView from "@/components/bulkAccessions/BulkAccessionsView";
export default {
  components: {
    BulkAccessionsView,
  },
  data() {
    return {
      statuses: ["PENDING"],
    };
  },
};
</script>
